import type { FC, TextareaHTMLAttributes } from 'react';

import { cn } from './cn.js';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

/** Многострочное поле - .textarea макета. */
export const Textarea: FC<TextareaProps> = ({ className, ...rest }) => (
  <textarea
    className={cn(
      'min-h-20 w-full resize-y rounded-[7px] border border-ink-200 bg-white px-[11px] py-[9px]',
      'text-[13px] text-ink-900 placeholder:text-ink-400 focus-visible:border-brand-green',
      'focus-visible:ring-2 focus-visible:ring-brand-green-50 focus-visible:outline-none',
      className,
    )}
    {...rest}
  />
);
